module.exports = __webpack_public_path__ + "static/media/policy-step-icon.30671631.svg";